import axios from 'axios';
import React, { useState } from 'react'

const ModleNewRefuond = ({memberId,
  isOpen,
  onClose,
  onSuccess,}) => {
 const [form, setForm] = useState({
    description: "",
    referenceNumber: "",
    price: "",
  });

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  if (!isOpen) return null;

  const setField = (key, val) => {
    setForm((p) => ({ ...p, [key]: val }));
  };

  const validate = () => {
    if (!form.description.trim()) return "חובה למלא תיאור";
    if (!form.referenceNumber.trim()) return "חובה למלא מספר אסמכתא";
    if (form.price === "" || Number.isNaN(Number(form.price)))
      return "חובה למלא מחיר (מספר)";
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    const v = validate();
    if (v) {
      setErrorMsg(v);
      return;
    }

    const payload = {
      description: form.description.trim(),
      referenceNumber: form.referenceNumber.trim(),
      price: Number(form.price), // יכול להיות גם שלילי
    };

    try {
      setLoading(true);
      const res = await axios.post(
        `/admin/member/create_private_entitlement/${memberId}`,
        payload
      );

    //   onSuccess?.(res.data);
      onSuccess();

      // ניקוי טופס וסגירה
      setForm({ description: "", referenceNumber: "", price: "" });
      onClose();
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data ||
        "שגיאה בשליחת הבקשה";
      setErrorMsg(typeof msg === "string" ? msg : "שגיאה בשליחת הבקשה");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div dir="rtl" style={styles.backdrop} onMouseDown={onClose}>
      <div style={styles.modal} onMouseDown={(e) => e.stopPropagation()}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.headerTitle}>הוספת זכאות</div>
          <button type="button" onClick={onClose} style={styles.xBtn}>
            ×
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} style={styles.body}>
          <div style={styles.field}>
            <label style={styles.label}>תיאור</label>
            <input
              value={form.description}
              onChange={(e) => setField("description", e.target.value)}
              style={styles.input}
              placeholder='לדוגמה: "הפחת הזכיאוים"'
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>מספר אסמכתא</label>
            <input
              value={form.referenceNumber}
              onChange={(e) => setField("referenceNumber", e.target.value)}
              style={styles.input}
              placeholder="152322245"
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>מחיר (יכול להיות מינוס)</label>
            <input
              value={form.price}
              onChange={(e) => setField("price", e.target.value)}
              style={styles.input}
              placeholder="-5000"
              inputMode="decimal"
            />
          </div>

          {errorMsg && <div style={styles.error}>{errorMsg}</div>}

          {/* Footer buttons */}
          <div style={styles.footer}>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={styles.cancelBtn}
            >
              ביטול
            </button>
            <button type="submit" disabled={loading} style={styles.saveBtn}>
              {loading ? "שומר..." : "שמור"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 23, 42, 0.35)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: 16,
  },
  modal: {
    width: "min(720px, 96vw)",
    background: "#fff",
    borderRadius: 10,
    overflow: "hidden",
    boxShadow: "0 18px 60px rgba(0,0,0,0.25)",
    border: "1px solid rgba(0,0,0,0.08)",
  },
  header: {
    background: "#0B3A5A",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 14px",
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: 800,
  },
  xBtn: {
    width: 34,
    height: 34,
    borderRadius: 6,
    border: "1px solid rgba(255,255,255,0.35)",
    background: "transparent",
    color: "#fff",
    fontSize: 22,
    lineHeight: "30px",
    cursor: "pointer",
  },
  body: {
    padding: 16,
    display: "grid",
    gap: 12,
  },
  field: {
    display: "grid",
    gap: 6,
  },
  label: {
    fontSize: 13,
    color: "#334155",
    fontWeight: 700,
  },
  input: {
    height: 42,
    borderRadius: 8,
    border: "1px solid #CBD5E1",
    padding: "0 12px",
    fontSize: 14,
    outline: "none",
  },
  error: {
    background: "#FEE4E2",
    color: "#B42318",
    border: "1px solid #FDA29B",
    padding: "10px 12px",
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 700,
  },
  footer: {
    display: "flex",
    gap: 10,
    justifyContent: "flex-start",
    paddingTop: 6,
  },
  cancelBtn: {
    height: 38,
    padding: "0 16px",
    borderRadius: 8,
    border: "1px solid #94A3B8",
    background: "#E2E8F0",
    cursor: "pointer",
    fontWeight: 700,
  },
  saveBtn: {
    height: 38,
    padding: "0 18px",
    borderRadius: 8,
    border: "1px solid #16A34A",
    background: "#22C55E",
    cursor: "pointer",
    fontWeight: 800,
    color: "#052e16",
  },
}

export default ModleNewRefuond